module.exports = __webpack_public_path__ + "img/17.de96af8c.jpg";